import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUsers,
  faUserShield,
  faFileInvoiceDollar,
  faCog,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from '@fortawesome/free-solid-svg-icons';

function SidebarDivider() {
  return (
    <li className="sidebar-nav-divider" role="presentation" aria-hidden="true">
      <span className="sidebar-nav-divider-line" />
    </li>
  );
}

function SuperAdminSidebar({ isCollapsed, onToggle }) {
  const location = useLocation();

  const NavRow = ({ path, title, children, testActive }) => {
    const active = testActive ? testActive() : location.pathname.startsWith(path);

    return (
      <li className={`nav-item ${active ? 'active' : ''}`.trim()} title={title}>
        <Link to={path} className="nav-link">
          {children}
        </Link>
      </li>
    );
  };

  return (
    <div className={`sidebar-container ${isCollapsed ? 'collapsed' : ''}`}>
      <Link
        to="/"
        className="sidebar-logo sidebar-logo--tooltip-host"
        aria-describedby="super-admin-sidebar-logo-landing-hint"
      >
        <img src={window.getPublicUrl('/assets/images/logo.png')} alt="Fam Connect" />
        <span
          className="sidebar-logo-tooltip"
          id="super-admin-sidebar-logo-landing-hint"
          role="tooltip"
        >
          Back to Landing Page
        </span>
      </Link>

      <nav className="sidebar-nav">
        <ul className="nav-list">
          <NavRow path="/super-admin/user-management" title="User Management">
            <div className="nav-icon">
              <FontAwesomeIcon icon={faUsers} />
            </div>
            {!isCollapsed && <span className="nav-text">User Management</span>}
          </NavRow>

          <NavRow path="/super-admin/admin-management" title="Admin Management">
            <div className="nav-icon">
              <FontAwesomeIcon icon={faUserShield} />
            </div>
            {!isCollapsed && <span className="nav-text">Admin Management</span>}
          </NavRow>

          <NavRow path="/super-admin/subscription-management" title="Subscription Management">
            <div className="nav-icon">
              <FontAwesomeIcon icon={faFileInvoiceDollar} />
            </div>
            {!isCollapsed && <span className="nav-text">Subscription Management</span>}
          </NavRow>

          <SidebarDivider />

          <NavRow
            path="/super-admin/settings/password"
            title="Settings"
            testActive={() =>
              location.pathname === '/super-admin/settings' ||
              location.pathname.startsWith('/super-admin/settings/password')
            }
          >
            <div className="nav-icon">
              <FontAwesomeIcon icon={faCog} />
            </div>
            {!isCollapsed && <span className="nav-text">Settings</span>}
          </NavRow>
        </ul>
      </nav>

      {!isCollapsed && (
        <div className="sidebar-copyright">
          <p className="sidebar-copyright-text">
            © {new Date().getFullYear()} FamConnect26. All rights reserved.
          </p>
        </div>
      )}

      <button type="button" className="collapse-toggle" onClick={onToggle}>
        <FontAwesomeIcon icon={isCollapsed ? faAngleDoubleRight : faAngleDoubleLeft} />
      </button>
    </div>
  );
}

export default SuperAdminSidebar;
